export const exchangeSections = [
    {
        title: 'Exchanges',
        items: ['Binance', 'Bitget', 'BitMart', 'ByBit', 'Coinbase', 'iTrust', 'Kraken', 'KuCoin', 'MexC', 'OKX', 'Robinhood'],
    },
    {
        title: 'Wallets',
        items: ['Base', 'Ledger', 'Tangem', 'Trust'],
    },
];

export const DEFAULT_PREFERRED_EXCHANGES = [
    'Coinbase',
    'Binance',
    'KuCoin',
    'Base',
    'Tangem',
    'iTrust',
];

export const resolvePreferredExchanges = (saved = []) => {
    if (Array.isArray(saved) && saved.length > 0) {
        return saved.filter((name) => LocalExchanges.includes(name));
    }
    return [...DEFAULT_PREFERRED_EXCHANGES];
};

const LocalExchanges = [...new Set(exchangeSections.flatMap((section) => section.items))];

export const sortExchangesByDisplayOrder = (names = []) =>
    [...names].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));

export const getToolbarExchanges = (preferred = []) =>
    sortExchangesByDisplayOrder(resolvePreferredExchanges(preferred));

export const splitExchangeSection = (section, selected = []) => {
    const selectedSet = new Set(selected);
    return {
        ...section,
        selectedItems: section.items.filter((name) => selectedSet.has(name)),
        availableItems: section.items.filter((name) => !selectedSet.has(name)),
    };
};

export const parseWalletNames = (wallet) => {
    if (!wallet) return [];
    try {
        const parsed = typeof wallet === 'string' ? JSON.parse(wallet) : wallet;
        if (Array.isArray(parsed)) return parsed.filter(Boolean);
    } catch {
        if (typeof wallet === 'string' && wallet.trim()) {
            return [wallet.trim()];
        }
    }
    return [];
};

export const collectExchangesFromAssets = (assets = []) => {
    const used = new Set();
    assets.forEach((row) => {
        parseWalletNames(row?.wallet).forEach((name) => {
            if (LocalExchanges.includes(name)) used.add(name);
        });
    });
    return sortExchangesByDisplayOrder([...used]);
};

export default LocalExchanges;
